import React, { useEffect, useState } from "react";
import Modal from "../../../../../context/modal/Modal";
import Checkbox from "../CheckBox";
import { OfferWindow } from "../../../../../models/vod/Models";
import BadgeList from "../BadgeList";
import { useGetContentMatchingContentGroupId } from "../../../../../services/vod/Query";


interface MutateFuncParams {
    id: string;
    tenants: string[];
}

interface Props {
    offerWindows?: OfferWindow[] | null;
    id: string;
    title: string;
    modalId: string;
    mutateFunc: (params: MutateFuncParams) => void;
    onClose?: () => void;
    openModal?: boolean;
}

const ExportModal = ({
    offerWindows,
    id,
    modalId,
    title,
    mutateFunc,
    onClose,
    openModal = false,
} : Props) => {
    const [ offerWindowsState, setOfferWindowsState ] = useState(offerWindows);
    const [ tenants, setTenants ] = useState<Set<string>>(new Set());

    const contentGroupId = offerWindows ? undefined : id;
    const { data, isSuccess } = useGetContentMatchingContentGroupId(contentGroupId ?? "");

    useEffect(() => {
        if (
            offerWindows &&
            (JSON.stringify(offerWindows) === JSON.stringify(offerWindowsState)
                || JSON.stringify(offerWindows) === JSON.stringify(data?.offerWindows))
        ) return;

        if (isSuccess && data) {
            setOfferWindowsState(data.offerWindows);
        } else if (offerWindows){
            setOfferWindowsState(offerWindows);
        }
    }, [ offerWindowsState, data, isSuccess, offerWindows ]);

    const submit = () => {
        mutateFunc({
            tenants: Array.from(tenants),
            id,
        });
        setTenants(new Set());
    };

    return (
        <>
            <Modal
                modalTitle={"Synamedia ADI Export"}
                modalId={modalId}
                modalSize={"w-[30vw] min-h-[25vh]"}
                onClose={onClose}
                openModal={openModal}
            >
                <Modal.Body>
                    <form className={`flex flex-col gap-3`} onSubmit={submit} id={`${modalId}-export-form`} method={"dialog"}>
                        <h2 className={`text-lg font-bold truncate`}>{title}</h2>
                        {
                            offerWindowsState && offerWindowsState.map((offerWindow) => {
                                return (
                                    <Checkbox
                                        values={tenants}
                                        value={offerWindow.tenantId as string}
                                        setValues={setTenants}
                                        key={`${offerWindow.offerType}_${offerWindow.name}_${offerWindow.tenantId}_${offerWindow.catalogues?.join(",")}_${offerWindow.depCode}`}
                                    >
                                        <p>{offerWindow.offerType}</p>
                                        <p>{offerWindow.tenantId}</p>
                                        {
                                            offerWindow.catalogues && offerWindow.catalogues.length > 0 &&
                                            <BadgeList items={offerWindow.catalogues.map(c => c.id) as string[]}/>
                                        }
                                    </Checkbox>
                                );
                            })
                        }
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <button form={`${modalId}-export-form`}
                            className={`text-white bg-brand-500 p-2 rounded-md font-bold`}
                    >
                        Submit
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ExportModal;